(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["air-cruiser-dark-faq"] && !window.DesignMode) return;
  try {
    
  (function(){

    function setFaqUnfold(){
      var faqList = document.querySelectorAll('.faq-list-item');
      faqList.forEach(function(item){
        let $i = $(item);
        $i.find('.faq-header').on('click', function(){
          $i.toggleClass('active');
          $i.find('.faq-copy').slideToggle();
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function(){
      setFaqUnfold();
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
